import { ApiQueryName } from "@/models/api"
import { useQuery } from "@tanstack/react-query"

import { useQueryKey, useRenameQueryResult } from "../utils"
import { useSigmaApi } from "./useSigmaApi"
import type { FetchSigmaTeamsOptions } from "./useSigmaApi"

type UseSigmaTeamsOptions = FetchSigmaTeamsOptions

/**
 * Gets the Sigma teams optionally filtered by team name
 *
 * @returns The Sigma teams
 *
 * @example
 * const {
 *   sigmaTeamsData,
 * } = useSigmaTeams()
 *
 * @example
 * const {
 *   sigmaTeamsData,
 * } = useSigmaTeams({
 *   name: "ABC Inc.",
 * })
 */
export const useSigmaTeams = (options: UseSigmaTeamsOptions = {}) => {
  const { fetchSigmaTeams, sigmaAccessTokenIsFetched } = useSigmaApi()

  const enabled = sigmaAccessTokenIsFetched

  const queryKey = useQueryKey(
    ApiQueryName.SigmaWorkbooks,
    "getMany",
    null,
    options
  )
  const queryResult = useQuery({
    enabled,
    queryFn: async () => fetchSigmaTeams(options),
    queryKey,
  })

  return useRenameQueryResult(queryResult, ApiQueryName.SigmaTeams)
}
